import React from 'react';
const PageBanner = props => {
   const { title } = props;
   return (
      <div
         className="page-banner"
         //style={{ backgroundImage: `url(${banner})` }}
      >
         <div className="justify-center">
            <div className="container justify-start">
               <h1 className="color-red quicksand">{title}</h1>
            </div>
         </div>
      </div>
   );
};

export default PageBanner;



// WEBPACK FOOTER //
// ./src/components/Banner/page-banner.js